// Brittfurn account widget, etablerar backend-session via HMAC-bootstrap från Liquid.
// Logout går till Shopify's egen logout-URL (sätter Shopify-cookie till logged-out),
// och vi rensar vår egen session-cookie via backend.

(function () {
  const BACKEND = (document.querySelector('meta[name="bf-backend-url"]') || {}).content
    || 'https://backend-sam-8064s-projects.vercel.app';

  // Bearer-token i localStorage, cookien är en tredjepartscookie som
  // Safari/inkognito blockerar. Samma nyckel delas med bf-upholstery.js (bfUpAuth).
  const TOKEN_KEY = 'bf_token';
  function getToken() { try { return localStorage.getItem(TOKEN_KEY) || ''; } catch { return ''; } }
  function setToken(t) { try { t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY); } catch {} }

  // Lokal JWT-koll istället för /api/account/me-rundtur: payloaden är läsbar
  // client-side (HS256-signaturen verifieras av backenden vid varje anrop ändå),
  // så exp + sub räcker för att avgöra om token är giltig för rätt kund.
  function tokenValidForCustomer(token) {
    try {
      const p = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
      if (p.exp && p.exp * 1000 < Date.now() + 60000) return false;
      return String(p.sub) === String(window.bfCustomerBootstrap.customer_id);
    } catch { return false; }
  }

  // Etablera backend-session om Liquid renderat customer-bootstrap.
  // Utan lokal token gör vi alltid exchange, cookien räcker inte i alla webbläsare.
  async function maybeExchange() {
    if (!window.bfCustomerBootstrap) return;

    const token = getToken();
    if (token) {
      if (tokenValidForCustomer(token)) return;
      setToken('');
    }

    try {
      const r = await fetch(BACKEND + '/api/account/exchange', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(window.bfCustomerBootstrap),
      });
      if (!r.ok) {
        const err = await r.text();
        console.warn('[bf-account] exchange misslyckades:', r.status, err.slice(0, 200));
        return;
      }
      const j = await r.json();
      if (j && j.token) setToken(j.token);
    } catch (e) {
      console.warn('[bf-account] exchange-anrop failade:', e.message);
    }
  }

  // Logout: rensa backend-cookie först, sen låt Shopify-länken redirecta
  function wireLogout(root) {
    root.addEventListener('click', async (e) => {
      const a = e.target.closest('[data-bf-logout]');
      if (!a) return;
      e.preventDefault();
      setToken('');
      try {
        await fetch(BACKEND + '/api/account/logout', { method: 'POST', credentials: 'include' });
      } catch (err) { /* ignore */ }
      location.href = a.getAttribute('href');
    });
  }

  async function init() {
    document.querySelectorAll('[data-bf-account]').forEach(wireLogout);
    await maybeExchange();
    document.dispatchEvent(new CustomEvent('bf:account-ready'));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
